import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import footerData from '../data/footer.json';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-about">
            <h3 className="footer-brand">
              <span className="brand-cyber">Cyber</span>
              <span className="brand-seqr">seqr</span>
            </h3>
            <p className="footer-parent">{footerData.parent}</p>
            <p className="footer-description">{footerData.description}</p>
            <div className="footer-social">
              {footerData.social.map((s) => (
                <a
                  key={s.platform}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={s.platform}
                >
                  <FaLinkedin />
                </a>
              ))}
            </div>
          </div>

          <div className="footer-links-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              {footerData.quickLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-contact">
            <h4 className="footer-heading">Contact Info</h4>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <p>{footerData.contact.address}</p>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <a href={`tel:${footerData.contact.phone}`}>{footerData.contact.phone}</a>
            </div>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <a href={`mailto:${footerData.contact.email}`}>{footerData.contact.email}</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {footerData.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
